/**
 * Helpers for showing the signed-in person in the top bar and account menu.
 * Pure: no React or MSAL imports.
 */

/** "Jordan Ellis" -> "JE"; "Ellis, Jordan" -> "JE"; "jordan" -> "J"; empty -> "?". */
export function getInitials(name?: string | null): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return "?";
  const ordered = trimmed.includes(",")
    ? trimmed.split(",").reverse().join(" ")
    : trimmed;
  const parts = ordered.split(/\s+/).filter(Boolean);
  const first = parts[0]?.charAt(0) ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return (first + last).toUpperCase() || "?";
}

/** Admin -> "Administrator", Developer -> "Developer", anyone else -> "CSI staff". */
export function roleLabelFor(roles: string[]): string {
  if (roles.includes("Admin")) return "Administrator";
  if (roles.includes("Developer")) return "Developer";
  return "CSI staff";
}
